/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DestinationListResponse = zod
	.array(
		zod
			.object({
				endpoint: zod.url().describe('Webhook endpoint URL'),
				environment_id: zod.string().describe('Environment ID this destination belongs to'),
				events: zod.array(zod.string()).describe('List of event types to subscribe to'),
				id: zod.string().describe('Destination ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				signing_secret: zod.string().describe('Webhook signing secret for verifying payloads'),
				status: zod.enum(['active', 'broken', 'disabled']),
				type: zod.enum(['webhook', 'callback']),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('Event destination configuration for delivering events to external systems')
	)
	.describe('List of event destinations');

export type DestinationListResponse = zod.input<typeof DestinationListResponse>;
export type DestinationListResponseOutput = zod.output<typeof DestinationListResponse>;
